import axios from 'axios';
import { apiRegions } from '../constants/api';
import { getToken } from '../services/AuthService';

// eslint-disable-next-line import/prefer-default-export
export const apiGetRegions = async () => {
  const token: string = await getToken();
  const data = await axios.get(
    `${process.env.REACT_APP_API_ROOT}${apiRegions}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
};
